import { RiChatAiLine, RiHome5Line, RiImageAiLine, RiLogoutBoxLine, RiMicAiLine, RiMovie2AiLine, RiRobot2Line, RiVideoAiLine, RiVideoOnAiLine } from "react-icons/ri";

export default {
    header: {
        self: {},
        items: [{}],
    },
    aside: {
        self: {},
        items: [
            {
                title: "Início",
                root: true,
                iconComponent: (
                    <div className="kt-menu__link-icon">
                        <RiHome5Line size={24} />
                    </div>
                ),
                page: "inicio",
                bullet: "dot",
            },
            {
                title: "Agentes",
                root: true,
                iconComponent: (
                    <div className="kt-menu__link-icon">
                        <RiRobot2Line size={24} />
                    </div>
                ),
                page: "agentes",
                bullet: "dot",
            },
            {
                title: "Gerador de imagem",
                root: true,
                iconComponent: (
                    <div className="kt-menu__link-icon">
                        <RiImageAiLine size={24} />
                    </div>
                ),
                page: "gerador-de-imagem",
                bullet: "dot",
            },
            {
                title: "Experts",
                root: true,
                iconComponent: (
                    <div className="kt-menu__link-icon">
                        <RiChatAiLine size={24} />
                    </div>
                ),
                page: "experts",
                bullet: "dot",
            },
            {
                title: "Gerador de voz",
                root: true,
                iconComponent: (
                    <div className="kt-menu__link-icon">
                        <RiMicAiLine size={24} />
                    </div>
                ),
                page: "gerador-de-voz",
                bullet: "dot",
            },
            {
                title: "Gerador de vídeo",
                root: true,
                iconComponent: (
                    <div className="kt-menu__link-icon">
                        <RiMovie2AiLine size={24} />
                    </div>
                ),
                page: "gerador-de-video",
                bullet: "dot",
            },
            {
                title: "ViralShort!",
                root: true,
                iconComponent: (
                    <div className="kt-menu__link-icon">
                        <RiVideoAiLine size={24} />
                    </div>
                ),
                page: "viral-short",
                bullet: "dot",
            },
            {
                title: "ViralCut!",
                root: true,
                iconComponent: (
                    <div className="kt-menu__link-icon">
                        <RiVideoOnAiLine size={24} />
                    </div>
                ),
                page: "viral-cut",
                bullet: "dot",
            },
        ],
        footerItems: [
            {
                title: "Sair",
                root: true,
                iconComponent: (
                    <div className="kt-menu__link-icon">
                        <RiLogoutBoxLine size={24} />
                    </div>
                ),
                page: "logout",
                bullet: "dot",
            },
        ],
    },
};
